module.exports = __webpack_public_path__ + "static/media/996554.d1a514f1.png";